import React from 'react';
import { Navbar, Nav, Container, Button, Card, Row, Col } from 'react-bootstrap';
import Calendar from "../components/EventsCalendar";

export default function Scheduling(){
    return (
        <div>
            <Navbar bg="light" expand="lg">
                <Container>
                    <Navbar.Brand href="#">
                        <div className="logo-wrapper">
                            <span className="logo-text">Email Send Scheduling</span>
                        </div>
                    </Navbar.Brand>
                </Container>
            </Navbar>
            <Calendar></Calendar>
        </div>
    )
} 